import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1edb78f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "share-button" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "icons/body/share",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      id: "分享2",
      "fill-rule": "nonzero"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        id: "矩形",
        fill: "#000000",
        opacity: "0",
        x: "0",
        y: "0",
        width: "24",
        height: "24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M20.4266667,13.4933333 C19.8933333,13.4933333 19.52,13.92 19.52,14.4533333 L19.52,15.5733333 C19.52,17.5466667 19.4666666,19.0933333 15.7866667,19.0933333 L8.32000001,19.0933333 C4.53333335,19.0933333 4.58666667,17.44 4.58666667,15.36 L4.58666667,10.72 C4.32,7.78666666 5.70666668,7.14666668 7.41333333,7.03999999 L7.46666667,7.03999999 C8.00000002,7.03999999 8.37333333,6.61333334 8.37333333,6.07999999 C8.37333333,5.54666665 7.94666667,5.11999999 7.46666667,5.11999999 L6.40000001,5.11999999 C4.32,5.11999999 2.66666667,6.77333332 2.66666667,8.85333333 L2.66666667,17.2266667 C2.66666667,19.3066667 4.32,20.96 6.40000001,20.96 L17.6,20.96 C19.68,20.96 21.3333333,19.3066667 21.3333333,17.2266667 L21.3333333,14.4533333 C21.3333333,13.92 20.9066667,13.4933333 20.4266667,13.4933333 Z M5.92000001,13.92 C5.92000001,14.88 6.08000002,15.7333333 6.34666666,16.5866667 C7.41333333,13.4933333 10.24,11.2533333 13.6,11.2533333 L13.6,12.5866667 C13.6,13.0666667 13.8666667,13.5466667 14.2933333,13.76 C14.4533333,13.8666667 14.6666667,13.92 14.88,13.92 C15.1466667,13.92 15.4133333,13.8133333 15.6266667,13.6533333 L20.7466667,9.65333334 C21.0666667,9.38666667 21.28,9.01333334 21.28,8.58666666 C21.28,8.15999998 21.0666667,7.78666666 20.7466667,7.51999999 L15.6266667,3.52000001 C15.4666667,3.30666668 15.2,3.25333334 14.9333333,3.25333334 C14.72,3.25333334 14.56,3.30666668 14.3466667,3.41333334 C13.92,3.62666667 13.6533333,4.10666667 13.6533333,4.58666667 L13.6533333,5.92000001 C9.38666667,5.92000001 5.92000001,9.49333334 5.92000001,13.92 L5.92000001,13.92 Z",
        id: "share-icon",
        fill: "#ffffff"
      })
    ])
  ])
], -1))
const _hoisted_3 = { class: "share-text-botton" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$checkI18n('share')), 1)
  ]))
}